/* eslint-disable react/prop-types */
import React from 'react';
import { useIntl } from 'react-intl';
import { Dialog, DialogContent, AppBar, DialogActions, Container, Button, Typography } from '@mui/material';

const MoreInfoDialog = function MoreInfoDialog({ valueName, open, close, currentProjectData }) {
  const intl = useIntl();
  return (
    <Dialog open={open} onClose={close} fullWidth>
      <AppBar sx={{ width: '100%', backgroundColor: '#00796b', padding: '1.5vh', color: '#fff', position: 'relative' }}>
        <Typography variant="subtitle1" sx={{ mr: '4.5vw' }}>
          {intl.messages.NOTES} {valueName}
        </Typography>
      </AppBar>
      <DialogContent>
        <Container>
          <Typography variant="body2" sx={{ wordWrap: 'break-word' }}>
            {currentProjectData[`${valueName}note`] || intl.messages.NONOTES}
          </Typography>
        </Container>
      </DialogContent>
      <DialogActions>
        <Button onClick={close} fullWidth variant="contained">
          {intl.messages.CLOSE}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoreInfoDialog;
